import { useAppState } from 'src/context';
import { useAddBooking } from 'src/hooks/queries/booking/useAddBooking';
import { useEffect } from 'react';
import type { TPostBookingPayload } from 'src/types';

export const useOnCreateConfirmationModalState = (
    props: TPostBookingPayload & { message: string; onClose: () => void }
) => {
    const {
        actions: { handleCloseModal },
    } = useAppState();
    const { onClose, message, ...rest } = props;

    const { mutateAsync: addAsync, isLoading: isAdding, isSuccess } = useAddBooking();

    useEffect(() => {
        if (isSuccess) {
            handleCloseModal();
        }
    }, [handleCloseModal, isSuccess, onClose]);

    const handleClickPrimaryButton = () => addAsync(rest);

    return {
        isAdding,
        handleClickPrimaryButton,
    };
};
